var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-notice"},[_c(_vm.homeConponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }